import React, { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import {
  fetchBookings,
  getBookingDetails,
  addNewBooking,
} from "../../actions/commonActions";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import moment from "moment";
import ShowBookingDetails from "./showBookingDetails";
import NewEventModal from "./newEventModal";
import { setPageTitle } from "../../utils/helper";
import "./styles.css"

const MOMENT_FORMAT = "YYYY-MM-DD";

export default function () {
  const [events, setEvents] = useState([]);
  const [showEventDetailsModal, setShowEventDetailsModal] = useState(null);
  const [eventDate, setEventDate] = useState(null);
  const [showNewEventModal, setShowNewEventModal] = useState(null);
  const [activeMonthDate, setActiveMonthDate] = useState(moment());
  const [newEventDate, setNewEventDate] = useState(null);

  const dispatch = useDispatch();

  const { bookings, bookingCreationStatus } = useSelector(
    (reduxState) => reduxState.common
  );

  // console.log("ALL BOOKINGS CHECK,", bookings)

  const calendarComponentRef = React.createRef();

  // Second parameter empty means It will only get called once on mount
  // If we skip second parameter it will be called everytime the state changes
  useEffect(() => {
    getBookings(activeMonthDate);
    setPageTitle("My Schedule");
  }, []);

  const getBookings = (date) => {
    const startOfMonth = moment(date).startOf("month").format(MOMENT_FORMAT);
    const endOfMonth = moment(date).endOf("month").format(MOMENT_FORMAT);
    const driver_id = localStorage.getItem("driver_id");
    fetchBookings(dispatch, startOfMonth, endOfMonth, driver_id);
  };

  useEffect(() => {
    if (bookingCreationStatus) {
      setShowNewEventModal(false);
    }
  }, [bookingCreationStatus]);

  useEffect(() => {
    let bookingsList = bookings.bookings;
    if (bookingsList && bookingsList.length > 0) {
      let eventsO = {};
      bookingsList.forEach((element) => {
        // const localStartDate = new Date(element.start_date_time); // Automatically converts to local time
        const utcStartDate = new Date(element.start_date_time + "Z"); // Adding 'Z' to explicitly mark it as UTC
        const localStartDate = utcStartDate.toLocaleString();        

        // const localEndDate = new Date(element.end_date_time); // Automatically converts to local time
        const utcEndDate = new Date(element.end_date_time + "Z"); // Adding 'Z' to explicitly mark it as UTC
        const localEndDate = utcEndDate.toLocaleString();        

        const start_date = moment(localStartDate).format(
          MOMENT_FORMAT
        );
        const end_date = moment(localEndDate).format(
          MOMENT_FORMAT
        );

        console.log("start_date====", element, localStartDate, start_date, localEndDate, end_date, eventsO, bookings);
        if (eventsO[start_date] !== undefined) {
          eventsO[start_date] = eventsO[start_date] + 1;
          if(start_date !== end_date){
            eventsO[end_date] = eventsO[end_date] + 1;
          }

        } else {
          eventsO[start_date] = 1;
          if(start_date !== end_date){
            eventsO[end_date] = 1;
          }
        }
      });

      let events = Object.keys(eventsO).map((key, index) => {
        return {
          title: "showLogo",
          id: eventsO[key],
          count: eventsO[key],
          start: key,
          onEventClick: eventClick,
        };
      });

      events = _.flatten(events.filter((e) => e !== undefined));
      setEvents(events);
    } else {
      setEvents([]);
    }
  }, [bookings]);

  const handleDateClick = (arg) => {
    const selectedDate = moment(arg.date);
    if (selectedDate.isSameOrBefore(moment(new Date()).subtract(1, "days")))
      return;
    setNewEventDate(selectedDate.format(MOMENT_FORMAT));
    setShowNewEventModal(true);
  };

  const eventClick = (info) => {
    const date = moment(info.event.start).format(MOMENT_FORMAT);
    setEventDate(date);
    setShowEventDetailsModal(true);
  };

  const gotoPast = () => {
    let calendarApi = calendarComponentRef.current.getApi();
    const date = moment(activeMonthDate, MOMENT_FORMAT)
      .subtract(1, "M")
      .endOf("month");
    setActiveMonthDate(date);
    getBookings(date);
    calendarApi.gotoDate(date.format(MOMENT_FORMAT));
  };

  const gotoNext = async () => {
    let calendarApi = calendarComponentRef.current.getApi();
    const date = moment(activeMonthDate, MOMENT_FORMAT)
      .add(1, "M")
      .endOf("month");
    setActiveMonthDate(date);
    await getBookings(date);
    calendarApi.gotoDate(date.format(MOMENT_FORMAT)); // call a method on the Calendar object
  };

  const onSubmit = (payload) => {
    addNewBooking(dispatch, payload, activeMonthDate);
  };

  return (
    <div className="container my-schedule">
      {/* <h1 className="title"></h1> */}
      <br />
      <FullCalendar
        // dayRender={(date, cell) => {
        //   alert("=====");
        //   if (date > new Date()) {
        //     // $(cell).addClass("disabled");
        //   }
        // }}
        plugins={[dayGridPlugin, interactionPlugin, bootstrapPlugin]}
        initialView="dayGridMonth"
        headerToolbar={{
          start: "prevButton",
          center: "title",
          end: "nextButton",
        }}
        customButtons={{
          prevButton: {
            text: `< `,
            click: gotoPast,
          },
          nextButton: {
            text: ` >`,
            click: gotoNext,
          },
        }}
        // eventColor="#ce0e0e"
        showNonCurrentDates={true}
        // color="#378006"
        titleFormat={{ year: "numeric", month: "short" }}
        events={events}
        ref={calendarComponentRef}
        eventClick={eventClick}
        dateClick={handleDateClick}
        eventContent={renderEventContent}
      // dayCellDidMount={(args) => {
      // if (args.isPast) {
      //   args.el.classList.add("past-cell");
      // }
      // if (args.date == new Date()) {
      // }
      // }}
      />
      {showEventDetailsModal ? (
        <ShowBookingDetails
          showEventDetailsModal={showEventDetailsModal}
          eventDate={eventDate}
          onClose={() => {
            setShowEventDetailsModal(false);
          }}
        />
      ) : null}
      {showNewEventModal ? (
        <NewEventModal
          showNewEventModal={showNewEventModal}
          onSubmit={onSubmit}
          date={newEventDate}
          onClose={() => {
            setShowNewEventModal(false);
          }}
        />
      ) : null}
    </div>
  );
}

function renderEventContent(eventInfo) {
  return (
    <div className="booking_logo">
      {eventInfo.event.title == "showLogo" && (
        <img
          src={require("../../images/ico.png")}
          // height="35px"
          // width="35px"
          onClick={() => { }}
          className={`mod ${eventInfo.event.start} -  ${eventInfo.event.end}`}
        />
      )}
      {eventInfo.event.extendedProps.count > 1 && (
        <span className="font-weight-bolder green-one-color">{`x${eventInfo.event.extendedProps.count}`}</span>
      )}
    </div>
  );

  if (eventInfo.event.title == "showLogo") {
    return (
      <img src={require("../../images/ico.png")} height="25px" width="25px" />
    );
  } else {
  }
  // return <></>;
  // else if (eventInfo.event.title == "isAvailableForMyPackage") {
  //   //white (true) and grey (if false)
  //   return (
  //     <svg height="20" width="20">
  //       <circle
  //         cx="10"
  //         cy="10"
  //         r="10"
  //         strokeWidth="3"
  //         className="fill-secondary"
  //       />
  //       Sorry, your browser does not support inline SVG.
  //     </svg>
  //   );
  // }
  // else if (eventInfo.event.title == "parking_slot_booking_id") {
  //   return <div className="cover"></div>;
  // }
}
